// Pills that each turn on or off (several chosen): a short list of known values to pick from.
import { Check } from "@phosphor-icons/react";

import { cn } from "./cn";

export function ToggleChips({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: readonly string[];
  value: readonly string[];
  onChange: (next: string[]) => void;
}) {
  const toggle = (o: string) => onChange(value.includes(o) ? value.filter((v) => v !== o) : [...value, o]);
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label={label}>
      {options.map((o) => {
        const on = value.includes(o);
        return (
          <button
            key={o}
            type="button"
            aria-pressed={on}
            onClick={() => toggle(o)}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[13px] font-medium transition-colors",
              on ? "border-primary bg-primary text-primary-foreground" : "border-muted bg-gray-0 text-gray-700 hover:border-gray-300 dark:bg-gray-50",
            )}
          >
            {on ? <Check weight="bold" className="h-3.5 w-3.5" aria-hidden /> : null}
            {o}
          </button>
        );
      })}
    </div>
  );
}
